export default __webpack_public_path__ + "static/media/textanalysis.ec311720.png";